module.exports = __CONFIG__ // eslint-disable-line
